import { Link } from "react-router-dom";
import type { GameSummary } from "../types/domain";
import { GameStatusPill } from "./GameStatusPill";

interface Props {
  game: GameSummary;
  tournamentName?: string;
  showTournamentName?: boolean;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function GameTitle({ title }: { title: string }) {
  const parts = title.split(/ vs /);
  if (parts.length !== 2) return <>{title}</>;
  return (
    <>
      {parts[0]} <span className="font-normal text-gray-400">vs.</span>{" "}
      {parts[1]}
    </>
  );
}

export function GameCard({
  game,
  tournamentName,
  showTournamentName = true,
}: Props) {
  return (
    <Link
      to={`/games/${game.id}`}
      className="card block no-underline transition hover:border-ember/40"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div
            className="font-semibold text-ink truncate"
            title={
              game.mode === "tournament" &&
              (game.leftPlayers || game.rightPlayers)
                ? `${game.leftPlayers} vs. ${game.rightPlayers}`
                : undefined
            }
          >
            <GameTitle title={game.title} />
          </div>
        </div>
        <div className="shrink-0 flex flex-col items-end gap-0.5">
          <div className="text-2xl font-bold tabular-nums text-ink">
            {game.scoreLeft} - {game.scoreRight}
          </div>
          <div className="text-[10px] font-medium uppercase tracking-wider text-smoke">
            {game.handsCount} levée{game.handsCount !== 1 && "s"}
          </div>
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between">
        <p className="text-[10px] font-medium uppercase tracking-wider text-smoke">
          {game.mode === "quick"
            ? "Partie rapide"
            : (showTournamentName && (tournamentName || game.tournamentName)) ||
              "Tournoi"}
          {" • "}
          {formatDate(game.createdAt)}
        </p>
        {game.status && <GameStatusPill status={game.status} />}
      </div>
    </Link>
  );
}
